var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.activeTransport)?_c('div',{staticClass:"connection-method-badge",attrs:{"title":`Connection method: ${_vm.activeTransport.name}`}},[_vm._v(" "+_vm._s(_vm.activeTransport.code)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }